// extracted by mini-css-extract-plugin
module.exports = {"description":"_78ab21f5"};